import { Container, Table, HourContent } from "../../styles";
import { HEIGHT_CELL_BODY, QUANTITY_PER_PAGE } from "../../utils/constants";
import { EmptyLabel, Header } from "./styles";
import { Content as ScheduleCellHeader } from "../ScheduleCellHeader/styles";
import { getHourList } from "utils/time";

const COLUMNS = Array(QUANTITY_PER_PAGE).fill();
const HOURS = getHourList();
const SchedulesSkelletonContent = () => {
    const renderHead = () => {
        return (
            <thead>
                <tr>
                    <th></th>
                    {COLUMNS.map((_, idx) => (
                        <th key={idx}>
                            <ScheduleCellHeader>
                                <Header className="main-content">
                                    <EmptyLabel width="80%"/>
                                </Header> 
                            </ScheduleCellHeader>
                        </th>
                    ))}
                </tr>
            </thead>
        );
    }
    const renderBody = () => {
        return (
            <tbody>
                {HOURS.map(hour => {
                    return (
                        <tr key={hour}>
                            <td>
                                <HourContent>
                                    <EmptyLabel width="60px"/>
                                </HourContent>
                            </td>
                            {COLUMNS.map((_, idx) => (
                                <td key={idx}>
                                    <EmptyLabel width="unset" height={`${HEIGHT_CELL_BODY}px`}/>
                                </td>
                            ))}
                        </tr>
                    );
                })}
            </tbody>
        );
    }
    return (
        <Container className="custom-scrollbar secondary">
            <Table>
                {renderHead()}
                {renderBody()}
            </Table>
        </Container>
    );
}

export default SchedulesSkelletonContent;